var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVDrm03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_82136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6523 6.73828H36.5664V5.39062C36.5664 3.15774 38.3765 1.34766 40.6094 1.34766C42.8423 1.34766 44.6523 3.15774 44.6523 5.39062V6.73828Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5664 6.73828V40.6094",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5664 39.2617V40.6094C36.5664 42.8423 34.7563 44.6523 32.5234 44.6523C30.2905 44.6523 28.4805 42.8423 28.4805 40.6094V39.2617H9.52344V6.73828C9.52344 3.76113 11.9369 1.34766 14.9141 1.34766H40.6094",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52344 39.2617H1.34766V40.6094C1.34766 42.8423 3.15774 44.6523 5.39062 44.6523H32.5234",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3516 28.3906H29.8281",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3516 33.7812H29.8281",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7852 9.43359C24.2965 9.43359 23.0898 8.2269 23.0898 6.73828C23.0898 8.2269 21.8832 9.43359 20.3945 9.43359H17.6992V14.1879C17.6992 17.8816 19.7862 21.2583 23.0898 22.9102C26.3935 21.2583 28.4805 17.8816 28.4805 14.1879V9.43359H25.7852Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_82136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVDrm03);
export default __webpack_public_path__ + "static/media/vDRM03.9d286514a6682df97ded646327c6f1b1.svg";
export { ForwardRef as ReactComponent };